// extracted by mini-css-extract-plugin
export default {"containerStyle":"styles_containerStyle__PQaU6","containerWrapperStyle":"styles_containerWrapperStyle__4jlB2","headerTextStyle":"styles_headerTextStyle__GA9h-"};